module.exports = __webpack_public_path__ + "static/media/ReferClient.e854875c.svg";